import { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '../ui/Input';
import { Card, CardHeader, CardTitle, CardDescription } from '../ui/Card';
import SeriesListItem from './SeriesListItem';

export default function CompactSeriesList({ series, onSeriesSelect, loading }) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredSeries = series.filter(s =>
    s.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return (
      <Card padding="compact" className="h-[calc(100vh-7rem)] flex flex-col">
        <CardHeader border={false}>
          <CardTitle>Select Series</CardTitle>
          <CardDescription>Choose a series to manage events, entries, and results</CardDescription>
        </CardHeader>
        <div className="space-y-2.5 flex-1">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-16 bg-slate-100 rounded animate-pulse" />
          ))}
        </div>
      </Card>
    );
  }

  return (
    <Card padding="compact" className="h-[calc(100vh-7rem)] flex flex-col">
      <CardHeader border={false}>
        <CardTitle>Select Series</CardTitle>
        <CardDescription>Choose a series to manage events, entries, and results</CardDescription>
      </CardHeader>

      <div className="mb-4">
        <Input
          placeholder="Search series..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          leftIcon={Search}
        />
      </div>

      <div className="space-y-1.5 flex-1 overflow-y-auto">
        {filteredSeries.length === 0 ? (
          <div className="text-center py-10 text-slate-500 text-sm">
            {searchQuery ? 'No series match your search' : 'No series available'}
          </div>
        ) : (
          filteredSeries.map((s) => (
            <SeriesListItem
              key={s.id}
              series={s}
              onClick={onSeriesSelect}
            />
          ))
        )}
      </div>
    </Card>
  );
}
